/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_CtaInputs */

const en_mk_team_cta = /** @type {(inputs: Mk_Team_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open a project and start a team`)
};

const id_mk_team_cta = /** @type {(inputs: Mk_Team_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka proyek dan mulai tim`)
};

/**
* | output |
* | --- |
* | "Open a project and start a team" |
*
* @param {Mk_Team_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_cta = /** @type {((inputs?: Mk_Team_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_cta(inputs)
	return en_mk_team_cta(inputs)
});